import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/articles';

export default function CategoryOverview() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            {t('section_categories')}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            {t('section_categories_desc')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg p-6 border border-background-200/70 hover:border-secondary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 mb-4 group-hover:bg-secondary-200 transition-colors">
                <i className={`${cat.icon} text-xl`} />
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-secondary-700 transition-colors">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                {cat.description}
              </p>
              <span className="text-xs text-foreground-500">
                {cat.count} 篇文章
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}